import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DoneIcon from '@mui/icons-material/Done';
import { Divider, Paper, Typography } from '@mui/material';

interface PasswordRulesDisplayProps {
  constraints: { constraint: string; valid: boolean }[];
  fieldsAreDirty?: boolean;
}

const PasswordRulesDisplay = ({
  constraints,
  fieldsAreDirty,
}: PasswordRulesDisplayProps) => {
  return (
    <Paper
      sx={{
        padding: 1,
        backgroundColor: 'inherit',
        height: 'fit-content',
        justifyContent: 'center',
      }}
      variant="outlined"
    >
      <Typography
        align="center"
        variant="body2"
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        Please ensure your password meets the following requirements:
      </Typography>
      <Divider sx={{ marginY: 1 }} />
      {constraints.map(({ constraint, valid }) => {
        const color = !fieldsAreDirty
          ? ''
          : `${valid ? 'success' : 'error'}.main`;
        const Icon = !fieldsAreDirty
          ? KeyboardArrowRightIcon
          : valid
            ? DoneIcon
            : ErrorOutlineIcon;
        return (
          <Typography
            key={constraint}
            variant="caption"
            color={color}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <Icon sx={{ width: 15, marginRight: 1 }} />
            {constraint}
          </Typography>
        );
      })}
    </Paper>
  );
};

export default PasswordRulesDisplay;
